import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from '../../config';

/* I campi mappabili li dice il SERVER (campo `campi` della risposta di /import/upload).
   Questo elenco e' solo il ripiego per una risposta vecchia: tenerne due a mano voleva dire
   che un campo aggiunto di la' non compariva di qua, e la schermata diceva «ignora colonna»
   mentre il dato entrava lo stesso — successo con «Settore» (13/10/2026). */
const CAMPI_RIPIEGO = [
  { value: 'telefono', label: 'Telefono' },
  { value: 'cellulare', label: 'Cellulare' },
  { value: 'ragione_sociale', label: 'Ragione sociale' },
  { value: 'partita_iva', label: 'Partita IVA' },
  { value: 'codice_fiscale', label: 'Codice fiscale' },
  { value: 'indirizzo', label: 'Indirizzo' },
  { value: 'civico', label: 'Civico' },
  { value: 'cap', label: 'CAP' },
  { value: 'comune', label: 'Comune' },
  { value: 'provincia', label: 'Provincia' },
  { value: 'settore', label: 'Settore' },
  { value: 'consenso', label: 'Consenso' },
];
const IGNORA = { value: '', label: '— Ignora colonna —' };

export default function StepMappatura({ headers, mapping, preview, zeroTroncato, campi, onMappingChange, onZeroTroncatoChange, onConfirm, onBack }) {
  const SYSTEM_FIELDS = [IGNORA, ...((campi && campi.length)
    ? campi.map(c => ({ value: c.valore, label: c.etichetta }))
    : CAMPI_RIPIEGO)];
  /* Quale colonna tiene ogni campo: serve a dire «già su ...» invece di una voce spenta e
     basta, e a mostrare sotto la tabella la quadra di cosa verrà importato. */
  const colonnaDi = {};
  (headers || []).forEach(h => { const v = mapping[h]; if (v) colonnaDi[v] = h; });
  const usedFields = new Set(Object.keys(colonnaDi));
  /* Due modi di avere un file lavorabile, e ne basta uno: una colonna di NUMERI (i fissi
     entrano in archivio) oppure NOME + COMUNE (senza numero la riga va in «Da qualificare» e
     l'agente cerca l'azienda). Prima si pretendeva sempre il telefono: un vincolo rimasto
     indietro rispetto alle tre uscite dell'import (13/10/2026). */
  const phoneMapped = usedFields.has('telefono') || usedFields.has('cellulare');
  const ragioneSocialeMapped = usedFields.has('ragione_sociale');
  const comuneMapped = usedFields.has('comune');
  const siPuoProseguire = phoneMapped || (ragioneSocialeMapped && comuneMapped);
  const mancaPerCercare = [!ragioneSocialeMapped && 'la ragione sociale',
                           !comuneMapped && 'il comune'].filter(Boolean).join(' e ');
  const ignorate = (headers || []).filter(h => !mapping[h]);

  const [salvate, setSalvate] = useState([]);
  const [nome, setNome] = useState('');

  const caricaElenco = () => {
    axios.get(`${API}/import/mappings`).then(r => setSalvate(r.data.items || [])).catch(() => {});
  };
  useEffect(() => { caricaElenco(); }, []);

  function handleChange(colName, value) {
    onMappingChange({ ...mapping, [colName]: value });
  }

  const applica = (m) => {
    if (!m) return;
    // riparti da una mappa pulita sugli header attuali, poi applica quella salvata.
    // Un campo che nella mappatura salvata finisse su due colonne (ne esistono di salvate
    // prima del 13/10/2026) resta sulla prima: due colonne sullo stesso campo bloccano
    // l'importazione, e si bloccherebbe senza che nessuno abbia toccato niente.
    const next = {};
    const presi = new Set();
    (headers || []).forEach(h => {
      const v = (m.mapping && m.mapping[h]) || '';
      next[h] = (v && presi.has(v)) ? '' : v;
      if (v) presi.add(v);
    });
    onMappingChange(next);
    onZeroTroncatoChange(!!m.zero_troncato);
    toast.success(`Mappatura «${m.nome}» applicata`);
  };

  const salva = async () => {
    const n = nome.trim();
    if (!n) { toast.error('Dai un nome alla mappatura'); return; }
    try {
      await axios.post(`${API}/import/mappings`, { nome: n, mapping, zero_troncato: !!zeroTroncato });
      toast.success(`Mappatura «${n}» salvata`);
      setNome('');
      caricaElenco();
    } catch (e) { toast.error(e?.response?.data?.detail || 'Errore salvataggio'); }
  };

  const elimina = async (n) => {
    if (!window.confirm(`Eliminare la mappatura «${n}»?`)) return;
    try { await axios.delete(`${API}/import/mappings/${encodeURIComponent(n)}`); caricaElenco(); }
    catch (e) { toast.error(e?.response?.data?.detail || 'Errore'); }
  };

  return (
    <div className="card">
      <h2>Mappatura Colonne</h2>

      {/* Barra: carica/salva mappatura */}
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center', marginBottom: 14 }}>
        <select onChange={e => applica(salvate.find(x => x.nome === e.target.value))} value=""
          style={{ padding: '7px 9px', border: '1px solid #cbd5e1', borderRadius: 8, fontSize: 13, minWidth: 200 }}>
          <option value="">Carica mappatura salvata…</option>
          {salvate.map(m => <option key={m.nome} value={m.nome}>{m.nome}</option>)}
        </select>
        {salvate.length > 0 && (
          <span style={{ fontSize: 12, color: '#94a3b8' }}>
            {salvate.map(m => (
              <button key={m.nome} type="button" onClick={() => elimina(m.nome)} title={`Elimina ${m.nome}`}
                style={{ border: 'none', background: 'none', color: '#ef4444', cursor: 'pointer', fontSize: 12, marginRight: 6 }}>
                {m.nome} &#x2715;
              </button>
            ))}
          </span>
        )}
        <span style={{ marginLeft: 'auto', display: 'flex', gap: 6 }}>
          <input value={nome} onChange={e => setNome(e.target.value)} placeholder="Nome fornitore"
            style={{ padding: '7px 9px', border: '1px solid #cbd5e1', borderRadius: 8, fontSize: 13, width: 160 }} />
          <button className="btn btn-secondary" onClick={salva}>Salva mappatura</button>
        </span>
      </div>

      {/* Toggle zero troncato */}
      <label style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px', marginBottom: 14,
        background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 8, cursor: 'pointer', fontSize: 13 }}>
        <input type="checkbox" checked={!!zeroTroncato} onChange={e => onZeroTroncatoChange(e.target.checked)}
          style={{ width: 17, height: 17, cursor: 'pointer' }} />
        <span>
          <strong>I fissi hanno lo zero iniziale troncato da Excel</strong>
          <span style={{ display: 'block', fontSize: 12, color: '#64748b' }}>
            Attiva SOLO se in questo file i numeri fissi sono senza lo 0 iniziale (colonna numerica). Di default,
            un numero che non parte per 0 (verdi, a pagamento, esteri) viene scartato.
          </span>
        </span>
      </label>

      {!ragioneSocialeMapped && (
        <div style={{ marginBottom: 14, padding: '10px 14px', background: '#fffbeb',
          border: '1px solid #fcd34d', borderRadius: 8, color: '#b45309', fontSize: 13 }}>
          Attenzione: la colonna <strong>Ragione Sociale</strong> non è mappata.
        </div>
      )}

      <div style={{ overflowX: 'auto', marginBottom: 20 }}>
        <table>
          <thead>
            <tr>
              <th style={{ width: '30%' }}>Colonna file</th>
              <th style={{ width: '35%' }}>Mappa a campo</th>
              <th style={{ width: '35%' }}>Anteprima</th>
            </tr>
          </thead>
          <tbody>
            {headers.map((h, colIdx) => {
              const currentVal = mapping[h] || '';
              const samples = (preview || [])
                .map(row => Array.isArray(row) ? row[colIdx] : row[h])
                .filter(v => v !== undefined && v !== null && String(v).trim() !== '')
                .slice(0, 3);
              return (
                <tr key={h}>
                  <td style={{ fontWeight: 600, fontSize: 13 }}>{h}</td>
                  <td style={{ padding: '6px 8px' }}>
                    <select value={currentVal} onChange={e => handleChange(h, e.target.value)}
                      style={{ width: '100%', padding: '6px 8px', border: '1px solid #cbd5e1', fontSize: 13, background: 'var(--surface)' }}>
                      {SYSTEM_FIELDS.map(f => {
                        const altrove = f.value && f.value !== currentVal && colonnaDi[f.value];
                        return (
                          <option key={f.value} value={f.value} disabled={!!altrove}>
                            {f.label}{altrove ? ` — già su «${altrove}»` : ''}
                          </option>
                        );
                      })}
                    </select>
                  </td>
                  <td style={{ fontSize: 12, color: '#64748b', maxWidth: 220, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                      title={samples.join(' · ')}>
                    {samples.length ? samples.join(' · ') : '—'}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* La quadra: cosa verra' importato e da dove, in chiaro, PRIMA di andare avanti.
          Senza, l'unico modo di accorgersi di una colonna finita nel campo sbagliato era
          ritrovarsela in archivio (13/10/2026). */}
      <div style={{ marginBottom: 16, padding: '12px 14px', background: 'var(--surface-2)',
                    borderRadius: 8, fontSize: 13 }}>
        <strong>Verranno importati {usedFields.size} campi</strong>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px 14px', marginTop: 8 }}>
          {SYSTEM_FIELDS.filter(f => f.value && colonnaDi[f.value]).map(f => (
            <span key={f.value} style={{ color: 'var(--muted)' }}>
              {f.label}: <b style={{ color: 'var(--text)' }}>{colonnaDi[f.value]}</b>
            </span>
          ))}
        </div>
        {ignorate.length > 0 && (
          <div style={{ marginTop: 8, color: 'var(--muted)' }}>
            Colonne non importate: {ignorate.map(h => `«${h}»`).join(', ')}
          </div>
        )}
      </div>

      <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
        <button className="btn btn-secondary" onClick={onBack}>&#8592; Indietro</button>
        <button className="btn btn-primary" onClick={onConfirm} disabled={!siPuoProseguire}
          title={!siPuoProseguire
            ? 'Serve una colonna Telefono o Cellulare, oppure ragione sociale e comune'
            : ''}>
          Avanti &#8594;
        </button>
      </div>
      {!siPuoProseguire && (
        <p style={{ textAlign: 'right', fontSize: 12, color: '#ef4444', marginTop: 6 }}>
          Da questo file non si ricava né un numero né un’azienda da cercare: mappa una colonna
          <strong> Telefono</strong> o <strong>Cellulare</strong>, oppure {mancaPerCercare}.
        </p>
      )}
      {siPuoProseguire && !phoneMapped && (
        <p style={{ textAlign: 'right', fontSize: 12, color: 'var(--muted)', marginTop: 6 }}>
          Nessuna colonna di numeri: tutte le righe andranno in <strong>Da qualificare</strong>,
          dove l’agente cercherà l’azienda e il suo numero fisso.
        </p>
      )}
    </div>
  );
}
